import { SET_RANKING } from './types.js'
import axios from 'axios'

export default {
  setRanking({ commit }, payload) {
      commit(SET_RANKING, payload)
  },
  async requestRanking (state, parameters) {
    return axios.get('/api/ranking', { params: parameters })
      .then(response => {
        state.dispatch('setRanking', response.data.data.ranking)

        return Promise.resolve(response)
      })
      .catch(error => {

        return Promise.resolve(error)
      })
  },
}